export default "__VITE_ASSET__D$QRTh1v__"